import { Component, DestroyRef, viewChildren } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ToasterComponent, ToasterPlacement } from '@coreui/angular';
import { ToastItemComponent } from './toast-item.component';
import { ToastOptions } from './toast.interface';
import { ToastService } from './toast.service';

@Component({
  selector: 'app-toast-container',
  templateUrl: './toast-container.component.html',
  imports: [ToasterComponent],
  standalone: true,
})
export class ToastContainerComponent {
  readonly placements = Object.values(ToasterPlacement);
  readonly viewToasters = viewChildren(ToasterComponent);

  constructor(
    private toastService: ToastService,
    private destroyRef: DestroyRef,
  ) {
    this.toastService.toast$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((toast) => this.renderToast(toast));
  }

  private renderToast(toast: ToastOptions): void {
    const placement = toast.placement ?? ToasterPlacement.TopEnd;
    const toaster = this.viewToasters().find((item) => item.placement === placement);
    if (!toaster) {
      return;
    }

    const color = toast.color ?? ToastService.severityToColor(toast.severity);
    const icon = toast.icon ?? ToastService.severityToIcon(toast.severity);
    const title = toast.title ?? ToastService.severityToTitle(toast.severity) ?? 'Notificacion';
    const bodyTextColor = toast.textColor ?? ToastService.colorToTextColor(color);
    const headerColor = color === 'dark' ? 'dark' : 'light';
    const headerTextColor = headerColor === 'dark' ? 'light' : 'dark';

    const componentRef = toaster.addToast(ToastItemComponent, {}, {});
    componentRef.setInput('title', title);
    componentRef.setInput('message', toast.message);
    componentRef.setInput('icon', icon ?? '');
    componentRef.setInput('severity', toast.severity ?? '');
    componentRef.setInput('closeButton', toast.closeButton ?? true);
    componentRef.setInput('autohide', toast.autohide ?? true);
    componentRef.setInput('delay', toast.delay ?? 5000);
    componentRef.setInput('fade', toast.fade ?? true);
    componentRef.setInput('color', color ?? '');
    componentRef.setInput('textColor', bodyTextColor ?? '');
    componentRef.setInput('bodyTextColor', bodyTextColor ?? '');
    componentRef.setInput('headerColor', headerColor);
    componentRef.setInput('headerTextColor', headerTextColor);
    componentRef.setInput('visible', true);
  }
}
